import './Settings/Settings.css'
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import useScreenOrientation from '../Shared/DeviceOrientation.tsx';
import { Operators } from './Settings/Operators.tsx';
import { SettingsContainer } from './Settings/SettingsContainer.tsx';
import { PDFViewer, Document } from '@react-pdf/renderer';
import { Pages } from './PdfGenerator/Pages.tsx';
import { PdfSharedStyles as styles } from '../Shared/Pdf/Stylesheet.jsx';
import { SettingsContext } from './Settings/SettingsContext.tsx';
import { Email } from "react-obfuscate-email";
import AdsenseComponent from '../Shared/AdSense.tsx';
import { Seo } from '../Shared/Seo/Seo.tsx';
import { RouteSeo } from '../Shared/Seo/routeSeo.ts';

export function MathFactsGenerator({ initialSettings, embedded = false }) {
    const [ settings, setSettings ] = useState(initialSettings);
    const operationTitle = settings.AllOperations ? "Math Facts" : settings.Page
    const pageTitle = settings.WordProblems ?
        operationTitle + " Word Problem Worksheet Generator" :
        operationTitle + " Worksheet Generator";

    const seoEntry: RouteSeo = {
        slug: typeof window !== 'undefined' ? window.location.pathname : '/',
        title: pageTitle + " | Math Pages",
        description: `Create and print free ${operationTitle.toLowerCase()} worksheets. ` +
            `Choose number ranges, set problems per page, and download a printable PDF with an answer key.`,
    };

    const hidePdfPreview =
        !(useScreenOrientation().toLowerCase().indexOf("portrait") >= 0) &&
        !isMobile ? '' : 'hidden';

    return(
        <SettingsContext.Provider value={{settings, setSettings}}>
            {!embedded && <Seo entry={seoEntry}/>}
            <AdsenseComponent/>
            <div>
                {!embedded && <h1>{pageTitle}</h1>}
                <Operators/>
                <SettingsContainer/>
                <Email email="mathpageshelp@gmail.com">To report a bug or request a feature, please email mathpageshelp@gmail.com</Email>
                <div id='pdfViewer' className={hidePdfPreview}> 
                    <PDFViewer style={styles.viewer}>
                        <Document title={'Math Facts'}>
                            <Pages settings={settings}/>
                        </Document>
                    </PDFViewer>
                </div>                       
            </div>
        </SettingsContext.Provider>
    );
}